export const GET_MESSAGES = `
query($channelId: ID, $start: Int, $limit: Int) {
    messages(
      where: { channelId: $channelId }
      start: $start
      limit: $limit
      sort: "created_at:desc"
    ) {
      id
      message
      created_at
      channelId {
        unread {
          id
        }
      }
      user {
        id
        firstName
        lastName
      }
    }
  }
`;